// extracted by mini-css-extract-plugin
export var label = "_5d-1";
export var reminder = "_5d-0";